import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import React, { useMemo, useState } from 'react';
import Chart from './chart';
import { Style } from './style';
import Widget from '../../widget';
import { legendConfig } from './config';
import DashboardPopover from '../../../components/Popover';
import { getPopupContainer } from '../../../../../helpers/popUp';
import { timelineOfIncidentsOptions, timelineOfIncidentsOptionsDefault } from '../../../../../helpers/filters/incidents';

const AssociatedEvents = ({ allData }) => {
  const { t } = useTranslation();
  const [period, setPeriod] = useState(timelineOfIncidentsOptionsDefault);
  const [legend, setLegend] = useState(legendConfig);

  const toggleLegend = (key) => {
    setLegend((prev) => prev.map((c) => {
      if (c.key === key) {
        return { ...c, toggled: !c.toggled };
      }
      return c;
    }));
  };

  const data = useMemo(() => {
    if (allData) {
      if (period === 'weekly') {
        return allData.past3Months;
      }
      return allData.past12Months;
    }
    return undefined;
  }, [allData, period]);

  const filteredByLegendData = useMemo(() => {
    const _data = {};
    if (!data) {
      return {}
    }

    const major = legend.find((l) => l.key === 'major').toggled;
    const moderate = legend.find((l) => l.key === 'moderate').toggled;
    const minor = legend.find((l) => l.key === 'minor').toggled;

    if (major) {
      _data.major = data.major
    }
    if (minor) {
      _data.minor = data.minor
    }
    if (moderate) {
      _data.moderate = data.moderate
    }

    return _data;
  }, [data, legend]);

  return (
    <Style>
      <Widget
        loading={!allData}
        title={t('Event Trend')}
        tooltip={(
          <DashboardPopover
            title={t('Event Trend')}
            body={t('Incidents and corrective actions reported by your information sources in connection with the selected supply chain.')}
          />
        )}
        header={(
          <div className="legend-cont flex-1 end">
            {legend.map((c) => (
              <div
                className={c.toggled ? 'item active' : 'item disabled'}
                key={`legend-${c.key}`}
                onClick={() => toggleLegend(c.key)}
              >
                <div className="cont flex-c jus-c">
                  <div className="legend" style={{ background: c.color }} />
                </div>
                <div className="cont flex-c jus-c">
                  <label>{t(c.label)}</label>
                </div>
              </div>
            ))}
            <Select
              {...getPopupContainer()}
              value={period}
              onChange={(v) => setPeriod(v)}
              style={{ width: 140 }}
            >
              {timelineOfIncidentsOptions.map((opt) => (
                <Select.Option
                  value={opt.value}
                  key={`options-${opt.value}`}
                >
                  {t(opt.label)}
                </Select.Option>
              ))}
            </Select>
          </div>
        )}
      >
        <div className="mb-3">
          <Chart data={filteredByLegendData} />
        </div>
      </Widget>
    </Style>
  );
};

export default AssociatedEvents;
